import NightCoverageEnum from 'constants/enums/NightCoverageEnum';
import NightStatusEnum from 'constants/enums/NightStatusEnum';
import { nightState } from './coverage';
import { isOffered } from './inheritance';

// Why Room rates sells nothing for a room on a night (yyyy-MM-dd), so Night
// rates can say so instead of showing an empty cell: { kind, season }, kind a
// NightStatusEnum. null when the night sells, or falls in a gap or a double
// the validation reports.
export const nightStatusOf = (model, roomId, date) => {
  const { state, seasonIds } = nightState(date, model.seasons);
  if (
    state !== NightCoverageEnum.COVERED &&
    state !== NightCoverageEnum.CLOSED
  ) {
    return null;
  }
  const season = model.seasons.find(({ id }) => id === seasonIds[0]);
  if (state === NightCoverageEnum.CLOSED) {
    return { kind: NightStatusEnum.CLOSED, season };
  }
  if (!isOffered(model, { roomId, seasonId: season.id })) {
    return { kind: NightStatusEnum.NOT_OFFERED, season };
  }
  return null;
};
